"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestAndPollReport = exports.downloadReport = exports.PdfClient = void 0;
const BaseClient_1 = require("../BaseClient");
class PdfClient extends BaseClient_1.BaseClient {
    constructor(baseUrl, tokenProvider) {
        super(baseUrl, tokenProvider);
    }
    /**
     * Start new PDF document generation
     * @param pdfRequest is passed to callback onGetUserJwtParams
     */
    requestReport(pdfRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'POST',
                url: '/api/v1/pdf/post',
                data: pdfRequest,
            });
            return response.data;
        });
    }
    /**
     * Check the status of a job
     */
    getStatus(jobId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance({
                method: 'GET',
                url: '/api/v1/pdf/status',
                params: {
                    jobId,
                },
            });
            return response.data;
        });
    }
}
exports.PdfClient = PdfClient;
/**
 * Download the pdf file associated with a given job id
 * @param jobId
 * @param downloadFileName
 */
function downloadReport(jobId, downloadFileName) {
    return __awaiter(this, void 0, void 0, function* () {
        if (BaseClient_1.baseClientDefaults.tokenProvider) {
            const jwt = yield BaseClient_1.baseClientDefaults.tokenProvider.onTokenRequest();
            downloadReportUsingJwt(jobId, jwt, downloadFileName);
        }
        else {
            window.open(getReportUrl(jobId, downloadFileName), '_blank');
        }
    });
}
exports.downloadReport = downloadReport;
function downloadReportUsingJwt(jobId, jwt, downloadFileName) {
    const form = document.createElement('form');
    form.method = 'post';
    form.target = '_blank';
    form.action = BaseClient_1.baseClientDefaults.baseUrl + '/api/v1/pdf/result';
    const inputs = [];
    inputs.push(`<input type="hidden" name="jobId" value="${jobId}">`);
    inputs.push(`<input type="hidden" name="jwt" value="${jwt}">`);
    if (downloadFileName) {
        inputs.push(`<input type="hidden" name="downloadFileName" value="${downloadFileName}">`);
    }
    form.innerHTML = inputs.join();
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
}
function getReportUrl(jobId, downloadFileName) {
    const downloadFileNameParam = downloadFileName ? '&downloadFileName=' + encodeURIComponent(downloadFileName) : '';
    return `${BaseClient_1.baseClientDefaults.baseUrl}/api/v1/pdf/result?jobId=${jobId}${downloadFileNameParam}`;
}
function requestAndPollReport(pdfRequest) {
    return __awaiter(this, void 0, void 0, function* () {
        const pdfClient = new PdfClient();
        const { jobId } = yield pdfClient.requestReport(pdfRequest);
        const status = yield pollReportStatus(pdfClient, jobId);
        return Object.assign({ jobId }, status);
    });
}
exports.requestAndPollReport = requestAndPollReport;
function pollReportStatus(pdfClient, jobId) {
    return __awaiter(this, void 0, void 0, function* () {
        let response = yield pdfClient.getStatus(jobId);
        while (response.status === 'InProgress') {
            yield new Promise((resolve) => {
                setTimeout(resolve, 1000);
            });
            response = yield pdfClient.getStatus(jobId);
        }
        return response;
    });
}
